import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export enum DIALOG_RESULT
{
	NO = 0,
	YES = 1,
	OK = 2
};

@Component({
	selector: 'app-yes-no-dialog',
	templateUrl: './yes-no-dialog.component.html',
	styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent {		

	public dialogResult = DIALOG_RESULT;

	constructor(@Inject(MAT_DIALOG_DATA) 
		public data: { title : string; content : string })
	{

	}	
}


